import { useContext } from "react";
import { ShowToast, ToastCtx } from "./ToastCtx.ts";

export function useToast(): ShowToast {
  const showToast = useContext(ToastCtx);
  if (!showToast) throw new Error("useToast must be used inside ToastProvider");
  return showToast;
}
